module.exports = __webpack_public_path__ + "media/npc_dota_hero_tinker.f0ed5576.webm";